import { useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import SectionCard from './layout/SectionCard';

const OUTCOME_MESSAGES = {
    success: { title: 'Payment successful', body: 'You can safely close this window.' },
    cancel: { title: 'Payment cancelled', body: 'You can safely close this window or return to the store.' },
};

export default function PaymentStatusReturn() {
    const { outcome } = useParams();
    const [searchParams] = useSearchParams();
    const p = searchParams.get('p');

    const normalized = String(outcome || '').toLowerCase();
    const copy = useMemo(() => {
        if (normalized === 'success') return OUTCOME_MESSAGES.success;
        if (normalized === 'cancel' || normalized === 'cancelled' || normalized === 'canceled') {
            return OUTCOME_MESSAGES.cancel;
        }
        return {
            title: 'Payment status',
            body: 'You can safely close this window.',
        };
    }, [normalized]);

    useEffect(() => {
        if (!p) return;
        const apiPath = normalized === 'cancelled' || normalized === 'canceled' ? 'cancel' : normalized;
        const q = new URLSearchParams({ p }).toString();
        window.location.replace(`${window.location.origin}/api/status/${apiPath}?${q}`);
    }, [p, normalized]);

    if (p) {
        return (
            <Container maxWidth="sm" sx={{ py: 6 }}>
                <SectionCard sx={{ textAlign: 'center', py: 6 }}>
                    <Typography variant="h5" gutterBottom>
                        Redirecting…
                    </Typography>
                </SectionCard>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <SectionCard sx={{ textAlign: 'center', py: 6 }}>
                <Typography variant="h5" gutterBottom>
                    {copy.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {copy.body}
                </Typography>
            </SectionCard>
        </Container>
    );
}
